<template>
  <div class="signature-container">
    <VueSignaturePad
      width="800px"
      height="320px"
      ref="signaturePad"
      :options="{ onBegin, onEnd }"
    />

    <input id="signature" name="signature" v-bind:value="this.signature" type="hidden" />
    <input
      id="signatureDateTime"
      name="signatureDateTime"
      v-bind:value="this.signatureDateTime"
      type="hidden"
    />

    <b-button @click="clearSignature" class="btn s-btn-b btn-gray mg-r-15">Réinitialiser</b-button>
  </div>
</template>
<script>
import VueSignaturePad from 'vue-signature-pad';

export default {
  name: 'SignaturePad',
  components: {
    VueSignaturePad,
  },
  props: {
    signatureDateTimeOriginal: String,
  },
  data() {
    return {
      signature: null,
      signatureDateTime: null,
      signatureDateTimeOriginalTmp: null,
    };
  },
  mounted() {
    this.signatureDateTimeOriginalTmp = this.signatureDateTimeOriginal;
  },
  methods: {
    onBegin() {
      this.$refs.signaturePad.resizeCanvas();
    },
    onEnd() {
      this.signature = this.getSignature();
      this.signatureDateTime = this.getDateTime();

      this.$emit('emitSignaturePadData', {
        'signature': this.signature,
        'signatureDateTime': this.signatureDateTime,
      });
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.signature = null;
      this.signatureDateTime = null;

      this.$emit('emitSignaturePadData', {
        'signature': this.signature,
        'signatureDateTime': this.signatureDateTimeOriginalTmp,
      });
    },
    getSignature() {
      var {data} = this.$refs.signaturePad.saveSignature();
      return data;
    },
    getDateTime() {
      var now = new Date();
      var year = "" + now.getFullYear();
      var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
      var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
      var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
      var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
      var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
  },
};
</script>

<style scoped>
.signature-container {
  border: solid 2px #404888;
}
</style>